export default "__VITE_ASSET__u6QvEEE0__"